import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericAPIService } from 'src/app/services/generic-api.service';
import { UrlConstants } from 'src/app/constants/url-constants';
import { NotificationConstants } from 'src/app/constants/notification-constants';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';

@Component({
  selector: 'app-admin-update-user-prediction',
  templateUrl: './admin-update-user-prediction.component.html',
  styleUrls: ['./admin-update-user-prediction.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminUpdateUserPredictionComponent implements OnInit {

  public userId: any;
  public raceId: any;
  public existingRaceEntryDetail: any;
  public raceInfoObj: any = { "Circuits": {} };
  public PreLoader: boolean = false;
  public PreLoaderForInfo: boolean = false;
  public PreLoaderForSave: boolean = false;

  public getRaceEntryUrl = UrlConstants.raceEntry;
  public getRaceInfoUrl = UrlConstants.raceInfo;
  public driverListUrl = UrlConstants.driversList;
  public constructorsListUrl = UrlConstants.constructorsList;
  public saveRaceEntryUrl = UrlConstants.saveEntry;

  public selectedDrivers = [];
  public selectedConstructors = [];
  public sprintEntryDrivers = [];
  public selectedFastestLap: any = {};
  public selectedPolePosition: any = {};
  public selectedMostPosition: any = {};

  public responseDriverList: any;
  public responseconstructorList: any;
  public DriverListForFastestLap = [];
  public DriverListForPolePosition = [];
  public DriverListForMostPosition = [];

  public showConstructorList: boolean = false;
  public showDriverList: boolean = false;
  public showRaceInfo: boolean = true;
  public showDriverListForFastestLap: boolean = false;
  public showDriverListForPolePosition: boolean = false;
  public showDriverListForMostPosition: boolean = false;

  public targetPosition: any;
  public SourceDetail: any;
  public targetConstructorPosition: any;
  public SourceConstructorDetail: any;
  public sourceFastestLap: any;
  public sourcePolePosition: any;
  public sourceMostPosition: any;

  public circuitSrc = "";
  public isSprintEntry: boolean = false;
  public showEditButton: boolean = true;

  public noDriver: string;
  public noConstructor: string;
  public noFastestLapDriver: string = NotificationConstants.noFastestLapDriverMsg;
  public noMostPlaceGained: string = NotificationConstants.noMostplaceGainedDriverMsg;
  public noPolePostionDriver: string = NotificationConstants.noPolePostionDriverMsg;

  constructor(
    private activatedRoute: ActivatedRoute,
    private genericService: GenericAPIService,
    private router: Router,
    private encryptDecryptService: EncryptDecryptService
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.userId = params['userId'];
      this.raceId = params['raceId'];
      if (this.userId && this.raceId) {
        this.fetchInitialData();
      }
    });
  }

  fetchInitialData() {
    this.PreLoader = true;
    this.formArrayObj();
    this.getRaceInfo();
    this.getDriversList();
    this.getConstructorsList();
    this.getUserRaceEntry();
  }

  formArrayObj() {
    this.selectedDrivers = [];
    for (let i = 1; i <= 6; i++) {
        let obj = this.emptyDriverObj();
        obj['position'] = i;
        this.selectedDrivers.push(obj);
    }
    this.sprintEntryDrivers = [];
    for (let i = 1; i <= 3; i++) {
        let obj = this.emptyDriverObj();
        obj['position'] = i;
        this.sprintEntryDrivers.push(obj);
    }
    this.selectedConstructors = [];
    for (let i = 1; i <= 3; i++) {
        let obj = this.emptyConstructorObj();
        obj['position'] = i;
        this.selectedConstructors.push(obj);
    }
    this.selectedPolePosition = this.emptyPoleObject();
    this.selectedFastestLap = this.emptyfastestLapObject();
    this.selectedMostPosition = this.emptymostPositionObject();
  }

  getRaceInfo() {
    this.PreLoaderForInfo = true;
    const url = `${this.getRaceInfoUrl}?raceId=${this.raceId}`;
    this.genericService.getAll(url).subscribe(response => {
      if (response.status.success === 'Success') {
        this.raceInfoObj = response.data;
        this.circuitSrc = response.data.Circuits.circuitImage;
      }
      this.PreLoaderForInfo = false;
    }, error => {
      this.PreLoaderForInfo = false;
      console.error('Error fetching race info', error);
    });
  }

  getDriversList() {
    this.genericService.getAll(this.driverListUrl + '?raceId=' + this.raceId).subscribe(response => {
      if (response.status.success === 'Success') {
        this.responseDriverList = response.data;
        this.DriverListForFastestLap = JSON.parse(JSON.stringify(response.data));
        this.DriverListForPolePosition = JSON.parse(JSON.stringify(response.data));
        this.DriverListForMostPosition = JSON.parse(JSON.stringify(response.data));
        this.filterFromList();
      }
    });
  }

  getConstructorsList() {
    this.genericService.getAll(this.constructorsListUrl + '?raceId=' + this.raceId).subscribe(response => {
      if (response.status.success === 'Success') {
        this.responseconstructorList = response.data;
        this.filterFromList();
      }
    });
  }

  getUserRaceEntry() {
    const url = `${this.getRaceEntryUrl}?userId=${this.userId}&raceId=${this.raceId}`;
    this.genericService.getAll(url).subscribe(response => {
      if (response.status.success === 'Success') {
        this.existingRaceEntryDetail = response.data;
        this.isSprintEntry = response.data.race.isSprintEntry || false;
        this.createArrayObj();
      }
      this.PreLoader = false;
    }, error => {
      this.PreLoader = false;
      console.error('Error fetching user race entry', error);
    });
  }

  createArrayObj() {
    if (this.existingRaceEntryDetail) {
      // Merge Drivers
      if (this.existingRaceEntryDetail.raceEntryDriverTRX && this.existingRaceEntryDetail.raceEntryDriverTRX.length > 0) {
        this.existingRaceEntryDetail.raceEntryDriverTRX.forEach(trx => {
          const slot = this.selectedDrivers.find(d => d.position === trx.position);
          if (slot) {
            Object.assign(slot, trx);
            slot.selected = (trx.drivers && trx.drivers.driverId) ? true : false;
          }
        });
      }
      // Merge Sprint
      if (this.existingRaceEntryDetail.raceEntrySprintTrx && this.existingRaceEntryDetail.raceEntrySprintTrx.length > 0) {
        this.existingRaceEntryDetail.raceEntrySprintTrx.forEach(trx => {
          const slot = this.sprintEntryDrivers.find(s => s.position === trx.position);
          if (slot) {
            Object.assign(slot, trx);
            slot.selected = (trx.drivers && trx.drivers.driverId) ? true : false;
          }
        });
      }
      // Merge Constructors
      if (this.existingRaceEntryDetail.raceEntryConstructorTRX && this.existingRaceEntryDetail.raceEntryConstructorTRX.length > 0) {
        this.existingRaceEntryDetail.raceEntryConstructorTRX.forEach(trx => {
          const slot = this.selectedConstructors.find(c => c.position === trx.position);
          if (slot) {
            Object.assign(slot, trx);
            slot.selected = (trx.constructors && trx.constructors.constructorId) ? true : false;
          }
        });
      }
      // Merge Lap Detail
      if (this.existingRaceEntryDetail.raceEntryLapDetail) {
        const lap = this.existingRaceEntryDetail.raceEntryLapDetail;
        if (lap.fastestLapDriver) {
          this.selectedFastestLap = JSON.parse(JSON.stringify(lap.fastestLapDriver));
          this.selectedFastestLap.selected = true;
        }
        if (lap.polePositionDriver) {
          this.selectedPolePosition = JSON.parse(JSON.stringify(lap.polePositionDriver));
          this.selectedPolePosition.selected = true;
        }
        if (lap.mostPlacesGainedDriver) {
          this.selectedMostPosition = JSON.parse(JSON.stringify(lap.mostPlacesGainedDriver));
          this.selectedMostPosition.selected = true;
        }
      }
      this.filterFromList();
    }
  }

  filterFromList() {
    if (!this.responseDriverList || !this.responseconstructorList) return;

    // Filter Drivers
    this.selectedDrivers.forEach(selected => {
      if (selected.selected && selected.drivers) {
        const idx = this.responseDriverList.findIndex(d => d.driverId === selected.drivers.driverId);
        if (idx > -1) this.responseDriverList.splice(idx, 1);
      }
    });

    // Filter Sprint
    this.sprintEntryDrivers.forEach(selected => {
      if (selected.selected && selected.drivers) {
        const idx = this.responseDriverList.findIndex(d => d.driverId === selected.drivers.driverId);
        if (idx > -1) this.responseDriverList.splice(idx, 1);
      }
    });

    // Filter Constructors
    this.selectedConstructors.forEach(selected => {
      if (selected.selected && selected.constructors) {
        const idx = this.responseconstructorList.findIndex(c => c.constructorId === selected.constructors.constructorId);
        if (idx > -1) this.responseconstructorList.splice(idx, 1);
      }
    });

    // Filter Other Lists
    if (this.selectedFastestLap.selected) {
      const idx = this.DriverListForFastestLap.findIndex(d => d.driverId === this.selectedFastestLap.driverId);
      if (idx > -1) this.DriverListForFastestLap.splice(idx, 1);
    }
    if (this.selectedPolePosition.selected) {
      const idx = this.DriverListForPolePosition.findIndex(d => d.driverId === this.selectedPolePosition.driverId);
      if (idx > -1) this.DriverListForPolePosition.splice(idx, 1);
    }
    if (this.selectedMostPosition.selected) {
      const idx = this.DriverListForMostPosition.findIndex(d => d.driverId === this.selectedMostPosition.driverId);
      if (idx > -1) this.DriverListForMostPosition.splice(idx, 1);
    }
  }

  emptyDriverObj() {
    return { 
      f1RaceEntryDriverTRXId: null,
      selected: false, 
      drivers: { driverId: '', foreName: '', surName: '', driverPic: '' },
      points: null,
      grainPoints: null
    };
  }

  emptyConstructorObj() {
    return { 
      f1RaceEntryConstructorTRXId: null,
      selected: false, 
      constructors: { constructorId: '', name: '', constructorPic: '' },
      points: null
    };
  }

  emptyPoleObject() {
    return { selected: false, polePositionDriver: { driverId: '', foreName: '', surName: '', driverPic: '' } };
  }

  emptyfastestLapObject() {
    return { selected: false, fastestLapDriver: { driverId: '', foreName: '', surName: '', driverPic: '' } };
  }

  emptymostPositionObject() {
    return { selected: false, mostPlacesGainedDriver: { driverId: '', foreName: '', surName: '', driverPic: '' } };
  }

  getposition(pos) {
    const list = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    return list[pos - 1] || pos;
  }

  showInfoOnly() {
    this.showRaceInfo = true;
    this.showDriverList = false;
    this.showConstructorList = false;
    this.showDriverListForFastestLap = false;
    this.showDriverListForPolePosition = false;
    this.showDriverListForMostPosition = false;
  }

  interchangeSourceTargetDriver() {
    if (this.SourceDetail && this.targetPosition) {
      let idx = this.selectedDrivers.indexOf(this.targetPosition);
      if (idx > -1) {
        if (this.selectedDrivers[idx].selected) {
          this.responseDriverList.push(this.selectedDrivers[idx].drivers);
        }
        this.selectedDrivers[idx].drivers = this.SourceDetail;
        this.selectedDrivers[idx].selected = true;
      } else {
        idx = this.sprintEntryDrivers.indexOf(this.targetPosition);
        if (idx > -1) {
          if (this.sprintEntryDrivers[idx].selected) {
            this.responseDriverList.push(this.sprintEntryDrivers[idx].drivers);
          }
          this.sprintEntryDrivers[idx].drivers = this.SourceDetail;
          this.sprintEntryDrivers[idx].selected = true;
        }
      }
      
      const sIdx = this.responseDriverList.indexOf(this.SourceDetail);
      if (sIdx > -1) this.responseDriverList.splice(sIdx, 1);
      this.showInfoOnly();
    }
  }

  interchangeSourceTargetSprintDriver() {
    // This is now handled within interchangeSourceTargetDriver
    this.interchangeSourceTargetDriver();
  }

  interchangeSourceTargetConstructor() {
    if (this.SourceConstructorDetail && this.targetConstructorPosition) {
      const idx = this.selectedConstructors.indexOf(this.targetConstructorPosition);
      if (idx > -1) {
        if (this.selectedConstructors[idx].selected) {
          this.responseconstructorList.push(this.selectedConstructors[idx].constructors);
        }
        this.selectedConstructors[idx].constructors = this.SourceConstructorDetail;
        this.selectedConstructors[idx].selected = true;
        const sIdx = this.responseconstructorList.indexOf(this.SourceConstructorDetail);
        if (sIdx > -1) this.responseconstructorList.splice(sIdx, 1);
        this.showInfoOnly();
      }
    }
  }

  FastestlapDetail() {
    if (this.sourceFastestLap) {
      if (this.selectedFastestLap.selected) {
        this.DriverListForFastestLap.push(this.selectedFastestLap);
      }
      this.selectedFastestLap = this.sourceFastestLap;
      this.selectedFastestLap.selected = true;
      const idx = this.DriverListForFastestLap.indexOf(this.sourceFastestLap);
      if (idx > -1) this.DriverListForFastestLap.splice(idx, 1);
      this.showInfoOnly();
    }
  }

  polePositionDetail() {
    if (this.sourcePolePosition) {
      if (this.selectedPolePosition.selected) {
        this.DriverListForPolePosition.push(this.selectedPolePosition);
      }
      this.selectedPolePosition = this.sourcePolePosition;
      this.selectedPolePosition.selected = true;
      const idx = this.DriverListForPolePosition.indexOf(this.sourcePolePosition);
      if (idx > -1) this.DriverListForPolePosition.splice(idx, 1);
      this.showInfoOnly();
    }
  }

  mostPositionGainedDetail() {
    if (this.sourceMostPosition) {
      if (this.selectedMostPosition.selected) {
        this.DriverListForMostPosition.push(this.selectedMostPosition);
      }
      this.selectedMostPosition = this.sourceMostPosition;
      this.selectedMostPosition.selected = true;
      const idx = this.DriverListForMostPosition.indexOf(this.sourceMostPosition);
      if (idx > -1) this.DriverListForMostPosition.splice(idx, 1);
      this.showInfoOnly();
    }
  }

  removeFromDriverList(obj) {
    const idx = this.selectedDrivers.indexOf(obj);
    if (idx > -1) {
      if (obj.drivers && obj.drivers.driverId) {
        this.responseDriverList.push(obj.drivers);
      }
      this.selectedDrivers[idx].drivers = { driverId: '', foreName: '', surName: '', driverPic: '' };
      this.selectedDrivers[idx].selected = false;
      this.selectedDrivers[idx].points = null;
      this.selectedDrivers[idx].grainPoints = null;
    }
  }

  removeFromSprintDriverList(obj) {
    const idx = this.sprintEntryDrivers.indexOf(obj);
    if (idx > -1) {
      if (obj.drivers && obj.drivers.driverId) {
        this.responseDriverList.push(obj.drivers);
      }
      this.sprintEntryDrivers[idx].drivers = { driverId: '', foreName: '', surName: '', driverPic: '' };
      this.sprintEntryDrivers[idx].selected = false;
      this.sprintEntryDrivers[idx].points = null;
    }
  }

  removeFromConstructorList(obj) {
    const idx = this.selectedConstructors.indexOf(obj);
    if (idx > -1) {
      if (obj.constructors && obj.constructors.constructorId) {
        this.responseconstructorList.push(obj.constructors);
      }
      this.selectedConstructors[idx].constructors = { constructorId: '', name: '', constructorPic: '' };
      this.selectedConstructors[idx].selected = false;
      this.selectedConstructors[idx].points = null;
    }
  }

  removeFromFastestLap() {
    this.DriverListForFastestLap.push(this.selectedFastestLap);
    this.selectedFastestLap = this.emptyfastestLapObject();
  }

  removeFromPolePosition() {
    this.DriverListForPolePosition.push(this.selectedPolePosition);
    this.selectedPolePosition = this.emptyPoleObject();
  }

  removeFromMostPosition() {
    this.DriverListForMostPosition.push(this.selectedMostPosition);
    this.selectedMostPosition = this.emptymostPositionObject();
  }

  save() {
    this.PreLoaderForSave = true;
    const adminId = +this.encryptDecryptService.getLocalStorage("userId");
    
    // Formatting the payload according to the required structure
    const payload: any = {
      updatedOnUI: new Date().toISOString(),
      createdOn: this.existingRaceEntryDetail ? this.existingRaceEntryDetail.createdOn : new Date().toISOString(),
      user: [
        {
          f1ApplicationUserId: +this.userId
        }
      ],
      race: {
        raceId: +this.raceId
      },
      isActive: true,
      createdBy: (this.existingRaceEntryDetail && this.existingRaceEntryDetail.createdBy) ? +this.existingRaceEntryDetail.createdBy : adminId,
      updatedBy: adminId,
      f1RaceEntryId: this.existingRaceEntryDetail ? +this.existingRaceEntryDetail.f1RaceEntryId : null,
    updatedByAdmin:adminId.toString(),
      raceEntryDriverTRX: this.selectedDrivers.map(d => ({
        f1RaceEntryDriverTRXId: d.f1RaceEntryDriverTRXId ? +d.f1RaceEntryDriverTRXId : null,
        position: +d.position,
        drivers: {
          driverId: (d.drivers && d.drivers.driverId) ? +d.drivers.driverId : null
        },
        points: d.points ? +d.points : null,
        grainPoints: d.grainPoints ? +d.grainPoints : null
      })),
      
      raceEntryConstructorTRX: this.selectedConstructors.map(c => ({
        f1RaceEntryConstructorTRXId: c.f1RaceEntryConstructorTRXId ? +c.f1RaceEntryConstructorTRXId : null,
        position: +c.position,
        constructors: {
          constructorId: (c.constructors && c.constructors.constructorId) ? +c.constructors.constructorId : null
        },
        points: c.points ? +c.points : null
      })),
      
      raceEntryLapDetail: {
        f1RaceEntryLapDetailId: (this.existingRaceEntryDetail && this.existingRaceEntryDetail.raceEntryLapDetail) ? +this.existingRaceEntryDetail.raceEntryLapDetail.f1RaceEntryLapDetailId : null,
        fastestLapDriver: this.selectedFastestLap.selected ? { driverId: +(this.selectedFastestLap.fastestLapDriver ? this.selectedFastestLap.fastestLapDriver.driverId : this.selectedFastestLap.driverId) } : null,
        mostPlacesGainedDriver: this.selectedMostPosition.selected ? { driverId: +(this.selectedMostPosition.mostPlacesGainedDriver ? this.selectedMostPosition.mostPlacesGainedDriver.driverId : this.selectedMostPosition.driverId) } : null,
        polePositionDriver: this.selectedPolePosition.selected ? { driverId: +(this.selectedPolePosition.polePositionDriver ? this.selectedPolePosition.polePositionDriver.driverId : this.selectedPolePosition.driverId) } : null
      },
      
      raceEntrySprintTrx: this.isSprintEntry ? this.sprintEntryDrivers.map(s => ({
        f1RaceEntrySprintTRXId: s.f1RaceEntrySprintTRXId ? +s.f1RaceEntrySprintTRXId : null,
        position: +s.position,
        drivers: {
          driverId: (s.drivers && s.drivers.driverId) ? +s.drivers.driverId : null
        },
        points: s.points ? +s.points : null
      })) : []
    };

    this.genericService.post(this.saveRaceEntryUrl, payload).subscribe(response => {
      this.PreLoaderForSave = false;
      if (response.status.success === 'Success') {
        this.router.navigate(['/admin/adminRacePrediction'], { 
          queryParams: { 
            raceId: this.raceId
          } 
        });
      }
    }, error => {
      this.PreLoaderForSave = false;
      console.error('Error saving entry', error);
    });
  }
}
